import { errorView, queryView, type QueryResultLike, type QueryView } from '@krp/client-runtime'

/**
 * Общие помощники селекторов (D-061, D-062): вид запроса и команды для экрана. Вход — НЕ RootState, а то, что binding выбрал: результаты
 * endpoint-ов и команд.
 */

/** Результат команды (RTK mutation) — ровно то, что нужно экрану. */
export interface MutationResultLike<T> {
  data?: T
  error?: unknown
  isUninitialized: boolean
  isLoading: boolean
  isError: boolean
  isSuccess: boolean
}

/** Состояние команды для экрана: идёт, отказ с причиной сервера, неизвестный исход. */
export interface ActionView {
  busy: boolean
  /** Причина отказа дословно (ADR-8) + код и корреляция для отчёта. */
  error: { kind: string; code: string; message: string; correlationId: string | null } | null
}

export function viewOf<T>(result: QueryResultLike<T>, isEmpty: (data: T) => boolean): QueryView {
  return queryView(
    {
      isUninitialized: result.isUninitialized,
      isLoading: result.isLoading,
      isError: result.isError,
      isSuccess: result.isSuccess,
      ...(result.error !== undefined ? { error: result.error } : {}),
      ...(result.data !== undefined ? { data: result.data } : {}),
    },
    isEmpty,
  )
}

/** Состояние команды: идёт ли, и причина отказа дословно (ADR-8). */
export function actionView(result: MutationResultLike<unknown> | null): ActionView {
  if (result === null) return { busy: false, error: null }
  if (result.isError && result.error !== undefined) {
    const error = errorView(result.error)
    return { busy: false, error: { kind: error.kind, code: error.code, message: error.message, correlationId: error.correlationId } }
  }
  return { busy: result.isLoading, error: null }
}
